import React from "react";
import { Accordion, Card, useAccordionButton } from "react-bootstrap";

function CustomToggle({ children, eventKey }) {
  const decoratedOnClick = useAccordionButton(eventKey, () =>
    console.log("totally custom!")
  );

  return (
    <label
      style={{ float: "right", cursor: "pointer" }}
      onClick={decoratedOnClick}
    >
      {children}
    </label>
  );
}

const SearchComponent = () => {
  return (
    <section
      className="ftco-section ftco-no-pb ftco-no-pt"
      style={{ marginTop: "3em" }}
    >
      <div className="fluid-container ml-4 mr-4">
        <div className="row">
          <div className="col-sm-3">
            <iframe
              style={{ width: "100%" }}
              height="100"
              src="https://www.youtube.com/embed/ryB764h7ivA"
              title="YouTube video player"
              frameborder="0"
              allow="fullscreen; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            ></iframe>
          </div>
          <div className="col-sm-6">
            <Accordion defaultActiveKey="0">
              <Card>
                <Card.Header style={{ height: 100 }}>
                  <div className="search">
                    <i className="fa fa-search"></i>{" "}
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Type City, Country, Tour Code or Tour Name to search"
                    />{" "}
                    <button className="btn btn-primary">Search</button>{" "}
                  </div>
                  <CustomToggle eventKey="1">
                    <u>Advanced Options</u>
                  </CustomToggle>
                </Card.Header>
                <Accordion.Collapse eventKey="1">
                  <Card.Body>
                    <div className="row">
                      <div className="col-sm-4">
                        <div>
                          <label style={{ color: "black" }}>Date:</label>
                          <br />
                          <input
                            type="date"
                            style={{ width: "100%", height: "2em" }}
                          />
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div>
                          <label style={{ color: "black" }}>Theme:</label>
                          <br />
                          <select
                            name="Any Theme"
                            id="Any Theme"
                            style={{ width: "100%", height: "2em" }}
                          >
                            <option value="beach">Beach</option>
                            <option value="saab">Saab</option>
                            <option value="opel">Opel</option>
                            <option value="audi">Audi</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <label style={{ color: "black" }}>
                          Departure From:
                        </label>
                        <br />
                        <select
                          name="Select Departure"
                          id="departure"
                          style={{ width: "100%", height: "2em" }}
                        >
                          <option value="beach">Beach</option>
                          <option value="saab">Saab</option>
                          <option value="opel">Opel</option>
                          <option value="audi">Audi</option>
                        </select>
                      </div>
                    </div>
                    <br />
                    <div className="row">
                      <div className="col-sm-12">
                        <label style={{ color: "black" }}>
                          Add Destinations :
                        </label>
                        <br />
                        <select
                          name="Select Destination"
                          id="departure"
                          style={{ width: "100%", height: "2em" }}
                        >
                          <option value="beach">Beach</option>
                          <option value="saab">Saab</option>
                          <option value="opel">Opel</option>
                          <option value="audi">Audi</option>
                        </select>
                      </div>
                    </div>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            </Accordion>
          </div>
          <div className="col-sm-3">
            <img
              src="https://images.pexels.com/photos/3361046/pexels-photo-3361046.jpeg?cs=srgb&dl=pexels-wendel-moretti-3361046.jpg&fm=jpg"
              height="100"
              style={{ width: "100%" }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default SearchComponent;
